// extracted by mini-css-extract-plugin
export default {"inputLtr":"formInputDirection_inputLtr__2QhfU","inputNameField":"formInputDirection_inputNameField__W4a9D"};